class AssetQuickEdit {
  constructor($quickEditContainer) {
    this.$quickEditContainer = $quickEditContainer;
    this.$quickEditButton = $quickEditContainer.find('#quick-edit-button');
    this.$details = $quickEditContainer.find('#quick-edit-detail');

    this.$quickEditButton.click(() => {
      return this.showDetails();
    });
  }

  showStepOne() {
    this.$quickEditContainer.show();
    this.$quickEditButton.show();
    return this.$details.hide();
  }

  showDetails() {
    this.$quickEditButton.hide();
    return this.$details.show();
  }

  hide() {
    this.$quickEditButton.hide();
    return this.$details.hide();
  }

  setupForAsset(asset) {
    if (asset) {
      this.showStepOne();
      return this.$details
        .find('form')
        .attr('action', `/projects/${asset.project_id}/assets/${asset.id}`);
    } else {
      return this.hide();
    }
  }
}

module.exports = AssetQuickEdit;
window.AssetQuickEdit = AssetQuickEdit;
